var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user_info.info_user.user_id)?_c('div',{staticClass:"PersonalInfo"},[(_vm.userData.show)?_c('StateInfo',{attrs:{"data":_vm.userData}}):_c('NoData')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }